module.exports = {
  popup_hints: {
    recog_model_button: 'Выбрать модель распознавания',
  },
  system: {
    timezone_default: 'По умолчанию',
    placeholder: 'Выберите',
  },
  create_new_ap_title: 'Создать проект',
  main_settings_title: 'Основные настройки',
  recog_model_modal_title: 'Список доступных моделей распознавания',
  delete_proj: 'Удалить проект',
  delete_proj_confirm: 'Все данные аналитического проекта, в том числе отчёты, будут удалены.',
  form_fields: {
    proj_name: 'Название проекта',
    group_proj: 'Группа проектов',
    proj_shared: 'Доступ к проекту',
    timezone: 'Временная зона',
    recog_model: 'Модель распознавания',
    groups: 'Группы пользователей',
  },
  buttons: {
    create_project: 'Создать',
    save_project: 'Сохранить',
    be_owner: 'Стать владельцем аналитического проекта',
    delete_project: 'Удалить проект',
  },
  // export import feature
  export_modal_label: 'Выберите нужные настройки',
  export_success: 'Успешный экспорт файла',
  export_error: 'Ошибка экспорта файла',
  import_success: 'Файл успешно импортирован',
  import_error: 'Ошибка импорта файла',
  download_ap_settings_button_label: 'Скачать настройки АП',
  import_ap_settings_button_label: 'Загрузить настройки из файла',
  // export import feature
};
